import { createAction, props } from '@ngrx/store';
import { AccordionItem } from '../accordion_item';

export const manualUpdate = createAction('[Manual] update', props<{accordionItems: Array<AccordionItem>}>());
export const manualChangeOpenState = createAction('[Manual] change open state', props<{itemToChange: any}>());
export const manualCloseAll = createAction('[Manual] close all');
